export type { BasicTextInputProps } from "./BasicTextInput";
export { default } from "./BasicTextInput";
